<template>
  <ontos-named-list-input ref="identity"
                          :name="value.name" :alias="value.alias"
                          :name-label="$tt('workflow-name')"
                          :fixed-alias="fixedAlias" :start-with-auto-alias="startWithAutoAlias"
                          :siblings="workflows"
                          @update:name="patch('name', $event)"
                          @update:alias="patch('alias', $event)">
    <ontos-state-list ref="states" editable :states="value.states" :title="$tt('states')"
                      icon="mdi-format-list-numbered" :level="3" dense
                      @update:entries="patch('states', $event)"/>
  </ontos-named-list-input>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import NamedListInput from '@/components/shared/NamedListInput.vue'
import StateList from '@/components/design/workflow/StateList.vue'
import Workflow from '@/types/Workflow'

/**
 * O editor de um fluxo de trabalho: nome, alias e a lista de situações — a identidade pelo
 * NamedListInput, como o domínio, e as situações pelo `StateList`, que é quem sabe delas.
 *
 * Continua existindo como componente para os hosts não mudarem: a página de criar, a de
 * editar e os dois modais conhecem este nome e chamam `validateModel()` pelo `$refs`.
 */
@Component({
  emits: ['input'],
  name: 'ontos-workflow-input',
  components: {'ontos-named-list-input': NamedListInput, 'ontos-state-list': StateList}
})
class WorkflowInput extends Vue {
  @Prop({type: Object, required: true}) readonly value!: Workflow
  @Prop({type: Boolean, default: false}) readonly fixedAlias!: boolean
  @Prop({type: Boolean, default: false}) readonly startWithAutoAlias!: boolean
  /** Os irmãos, para a unicidade de nome e alias do próprio fluxo. */
  @Prop({type: Array, default: () => []}) readonly workflows!: Workflow[]

  /** Saída única: o fluxo inteiro com o campo alterado. */
  patch(field: 'name' | 'alias' | 'states', value: any) {
    this.$emit('input', {...this.value, [field]: value})
  }

  /** O contrato com os hosts: eles validam por aqui antes de gravar. */
  validateModel(): boolean {
    //As duas metades, sem curto-circuito: os erros de todas aparecem de uma vez
    const states = (this.$refs.states as any).validateModel()
    return (this.$refs.identity as any).validateModel() && states
  }
}

export default toNative(WorkflowInput)
</script>
